/** Broker account scope for per-account dashboard layout persistence. */
export type DashboardLayoutAccountScope = {
  brokerName: string;
  brokerAccountCode: string;
};

export function isDashboardLayoutAccountScopeReady(
  scope: DashboardLayoutAccountScope | null | undefined
): scope is DashboardLayoutAccountScope {
  return Boolean(scope?.brokerName?.trim() && scope?.brokerAccountCode?.trim());
}

/** Stable key for React remounts and localStorage suffixes. */
export function dashboardLayoutAccountScopeKey(scope: DashboardLayoutAccountScope): string {
  return `${scope.brokerName.trim().toLowerCase()}:${scope.brokerAccountCode.trim()}`;
}

export function dashboardLayoutStorageKeys(scope: DashboardLayoutAccountScope): {
  layouts: string;
  activeLayoutId: string;
  backendIdMap: string;
} {
  const suffix = dashboardLayoutAccountScopeKey(scope);
  return {
    layouts: `dashboard_layouts_v2:${suffix}`,
    activeLayoutId: `dashboard_active_layout_id_v2:${suffix}`,
    backendIdMap: `dashboard_layout_backend_id_map_v2:${suffix}`,
  };
}
